import React from 'react';
import { DeleteOutlined, EyeOutlined, FolderOpenOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Card, Drawer, Flex, Image, List, Spin, Typography, Upload } from 'antd';

const { Text } = Typography;

const TILE_SIZE = 156;

const ImagePickerMobile = ({ viewModel }) => {
    const {
        loading,
        sheetOpen,
        setSheetOpen,
        confirmDelete,
        setConfirmDelete,
        previewSrc,
        acceptValue,
        uploadRef,
        handleUpload,
        triggerUpload,
        handlePreview,
        handleRemove,
        openLibrary,
    } = viewModel;

    return (
        <div style={{ width: TILE_SIZE }}>
            <Card
                hoverable
                size='small'
                styles={{ body: { display: 'none' } }}
                style={{ width: TILE_SIZE, overflow: 'hidden' }}
                cover={
                    <div
                        style={{ position: 'relative', aspectRatio: '1 / 1', overflow: 'hidden', cursor: 'pointer' }}
                        onClick={() => setSheetOpen(true)}
                    >
                        {previewSrc ? (
                            <Image
                                preview={false}
                                src={previewSrc}
                                alt='image'
                                fallback='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            />
                        ) : (
                            <Flex vertical align='center' justify='center' gap={8} style={{ position: 'absolute', inset: 0 }}>
                                <Button type='primary' shape='circle' size='large' loading={loading} icon={loading ? undefined : <PlusOutlined />} />
                                <Text type='secondary' style={{ fontSize: 12 }}>Chọn ảnh</Text>
                            </Flex>
                        )}

                        {loading && (
                            <Flex align='center' justify='center' style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.7)' }}>
                                <Spin />
                            </Flex>
                        )}
                    </div>
                }
            />

            {/* Hidden Upload triggered from sheet */}
            <div ref={uploadRef} style={{ display: 'none' }}>
                <Upload showUploadList={false} accept={acceptValue} beforeUpload={handleUpload} disabled={loading}>
                    <span />
                </Upload>
            </div>

            <Drawer
                placement='bottom'
                open={sheetOpen}
                onClose={() => { setSheetOpen(false); setConfirmDelete(false); }}
                height='auto'
                title='Tùy chọn ảnh'
                styles={{ body: { padding: '8px 0 16px' } }}
            >
                {confirmDelete ? (
                    <Flex vertical gap={12} style={{ padding: '8px 24px 0' }}>
                        <Text>Bạn có chắc muốn xóa ảnh này không?</Text>
                        <Flex gap={8}>
                            <Button block onClick={() => setConfirmDelete(false)}>Hủy</Button>
                            <Button block danger type='primary' onClick={handleRemove}>Xóa</Button>
                        </Flex>
                    </Flex>
                ) : (
                    <List itemLayout='horizontal'>
                        {previewSrc && (
                            <List.Item onClick={handlePreview} style={{ padding: '12px 24px', cursor: 'pointer' }}>
                                <List.Item.Meta avatar={<EyeOutlined style={{ fontSize: 20 }} />} title='Xem ảnh' />
                            </List.Item>
                        )}
                        <List.Item onClick={triggerUpload} style={{ padding: '12px 24px', cursor: 'pointer' }}>
                            <List.Item.Meta avatar={<UploadOutlined style={{ fontSize: 20 }} />} title={previewSrc ? 'Tải ảnh lên thay thế' : 'Tải ảnh lên'} />
                        </List.Item>
                        <List.Item onClick={openLibrary} style={{ padding: '12px 24px', cursor: 'pointer' }}>
                            <List.Item.Meta avatar={<FolderOpenOutlined style={{ fontSize: 20 }} />} title='Chọn từ thư viện' />
                        </List.Item>
                        {previewSrc && (
                            <List.Item onClick={() => setConfirmDelete(true)} style={{ padding: '12px 24px', cursor: 'pointer' }}>
                                <List.Item.Meta
                                    avatar={<DeleteOutlined style={{ fontSize: 20, color: '#ff4d4f' }} />}
                                    title={<Text style={{ color: '#ff4d4f' }}>Xóa ảnh</Text>}
                                />
                            </List.Item>
                        )}
                    </List>
                )}
            </Drawer>
        </div>
    );
};

export default ImagePickerMobile;
